/* eslint no-console: 0 */
import "core-js/stable";
import "regenerator-runtime/runtime";
import "bootstrap/dist/css/bootstrap.min.css";
import Vue from "vue";
import App from "../App.vue";
import "../styles/app.css";
import Toasted from "vue-toasted";
import VueRouter from "vue-router";
import RoutingMixin from "mixins/Routing";
import ModelParserMixin from "mixins/ModelParser";
import RouteHelpersMixin from "mixins/RouteHelpers";
import RequestsMixin from "mixins/http/RequestsMixin";
import DisplayErrors from "../components/DisplayErrors.vue";
import VIcon from "../components/VIcon.vue";
import "../initializers";

import router from "router";
import { loadTenantConfig } from "utils/tenantConfig";
import store from "store";

declare module "vue/types/vue" {
  interface Vue {
    $urlFor(name: string, ...args: any[]): string;
    $httpGet(url: string, tag: string): Promise<any>;
    $httpPost(url: string, tag: string, data: any): Promise<any>;
    $httpPut(url: string, tag: string, data: any): Promise<any>;
    $httpDelete(url: string, tag: string): Promise<any>;
    $moment: any;
    $mq: any;
  }
}

Vue.use(VueRouter);
window.addEventListener("load", () => {
  Vue.use(Toasted);
});
Vue.component("v-icon", VIcon);
Vue.component("display-errors", DisplayErrors);
Vue.mixin(RoutingMixin);
Vue.mixin(ModelParserMixin);
Vue.mixin(RouteHelpersMixin);
Vue.mixin(RequestsMixin);

// Fetch tenant branding config and apply CSS custom properties
loadTenantConfig()
  .then((config: any) => {
    const root = document.documentElement;
    // Apply the tenant primary color whenever the API returns one.
    // The API now returns null/empty when the tenant didn't pick a
    // color, so we never receive a "default sentinel" — every value
    // we get here is an explicit choice and must be applied.
    if (config.primary_color) {
      root.style.setProperty('--primary', config.primary_color);
      const hex = config.primary_color.replace('#', '');
      const rgb = [0, 2, 4].map((i) => parseInt(hex.substring(i, i + 2), 16));
      root.style.setProperty('--primary-rgb', rgb.join(', '));
      // Scale derived from the tenant color, as in the styleguide:
      // hover and text-on-tint are darker, tint and its border are
      // mixed with white.
      const mix = (target: number, amount: number) =>
        `#${rgb.map((v) => Math.round(v + (target - v) * amount).toString(16).padStart(2, '0')).join('')}`;
      root.style.setProperty('--primary-dark', mix(0, 0.17));
      root.style.setProperty('--primary-on-tint', mix(0, 0.2));
      root.style.setProperty('--primary-tint', mix(255, 0.92));
      root.style.setProperty('--primary-tint-border', mix(255, 0.78));
    }
    if (config.name) {
      document.title = config.name;
    }
  })
  .catch(() => {});

document.addEventListener("DOMContentLoaded", () => {
  const app = new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount();
  document.body.appendChild(app.$el);
});
